//Cugn cap cac style cho viec drawing
import React from "react";
import ol_style_Style from "ol/style/Style";
import ol_style_Fill from "ol/style/Fill";
import ol_style_Icon from "ol/style/Icon";
import ol_style_Text from "ol/style/Text";
import ol_style_Stroke from "ol/style/Stroke";
import ol_style_Circle from "ol/style/Circle";
import ol_Feature from "ol/Feature";
import ol_source_Vector from "ol/source/Vector";
import ol_geom_Point from "ol/geom/Point";

const myLib = require('../lib/MyLib');

var openSansAdded = false;
// http://stackoverflow.com/questions/14484787/wrap-text-in-javascript
function stringDivider(str, width, spaceReplacer) {
  if (str.length > width) {
    var p = width;
    while (p > 0 && str[p] !== " " && str[p] !== "-") {
      p--;
    }
    if (p > 0) {
      var left;
      if (str.substring(p, p + 1) === "-") {
        left = str.substring(0, p + 1);
      } else {
        left = str.substring(0, p);
      }
      var right = str.substring(p + 1);
      return left + spaceReplacer + stringDivider(right, width, spaceReplacer);
    }
  }
  return str;
}

var getText = function (feature, resolution) {
  var type = "normal";
  var maxResolution = 0.02;
  var geo = feature.get("type"); //xac dinh loai
  var text = "";
  if (geo === "Point") {
    var toado = feature.getGeometry().getCoordinates();
    var lon = toado[0];
    var lat = toado[1];
    text = '<a>' + myLib.latToDMS(lat) + '-' + myLib.lonToDMS(lon) + '</a>';
  }
  var placement = undefined;
  if (resolution > maxResolution) {
    text = "";
  } else if (type === "hide") {
    text = "";
  } else if (type === "shorten") {
    text = text.trunc(12);
  } else if (type === "wrap" && (!placement || placement !== "line")) {
    text = stringDivider(text, 16, "\n");
  }
  return text;
};

function createTextStyle(feature, resolution) {
  var align = "center";
  var baseline = "bottom";
  var size = "14px";
  var height = 1;
  var offsetX = 0;
  var offsetY = 24;
  var weight = "normal";
  var placement = undefined;
  var maxAngle = undefined;
  var overflow = undefined;
  var rotation = 0;
  var font = weight + " " + size + "/" + height + " Arial";
  var fillColor = "#aa3300";
  var outlineColor = "white";
  var outlineWidth = 3;

  var t = new ol_style_Text({
    textAlign: align == "" ? undefined : align,
    textBaseline: baseline,
    font: font,
    text: getText(feature, resolution),
    fill: new ol_style_Fill({ color: fillColor }),
    stroke: new ol_style_Stroke({ color: outlineColor, width: outlineWidth }),
    offsetX: offsetX,
    offsetY: offsetY,
    placement: placement,
    maxAngle: maxAngle,
    overflow: overflow,
    rotation: rotation,
  });
  return t;
}
export function drawStyleFunction(feature, resolution) {
  const type = feature.get("type");
  console.log("type of featur:", type);
  if (type === "Point") {
    return new ol_style_Style({
      image: new ol_style_Circle({
        radius: 5,
        stroke: new ol_style_Stroke({
          color: "rgba(0,0,255,0.5)",
          width: 2,
        }),
        fill: new ol_style_Fill({
          color: "#ffcc33",
        }),
      }),
    });
  }
  return undefined;
}
